<script>
    const svg = '<svg viewBox="0 0 2 2"><path d="M0,1L1,2 2,1 1,0" /></svg>';
</script>

{@html svg}
